import React from 'react';
import PropTypes from 'prop-types';
import { PaginationItem, PaginationLink } from 'reactstrap';

const PageFirst = ({ pagination, sheetsPerPage, dispatch, types, onSelected }) => {
    if (pagination.currentPage === 1) {
        return (
            <PaginationItem disabled>
                <PaginationLink previous={true} />
            </PaginationItem>
        );
    }
    return (
        <PaginationItem>
            <PaginationLink
                previous={true}
                onClick={() => {
                    if (dispatch && types)
                        dispatch({type: types, payload: 1})
                    else
                        onSelected(1)
                }}
            />
        </PaginationItem>
    );
};

PageFirst.propTypes = {
    pagination: PropTypes.object,
    sheetsPerPage: PropTypes.number,
    dispatch: PropTypes.func,
    types: PropTypes.string,
    onSelected: PropTypes.func
};

export default PageFirst;
